import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Center,
  Container,
  Flex,
  Image,
  Text,
  useToast,
} from "@chakra-ui/react";
import CustomInput from "../components/CustomInput";
import { FiEye, FiEyeOff } from "react-icons/fi";
import CustomButton from "../components/ButtonComp";
import { baseUrl } from "../utils/utils";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleLogin = async () => {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    try {
      const response = await fetch(baseUrl + "login", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log(data);

      if (response.ok && data.success) {
        localStorage.setItem("authToken", data.user);
        localStorage.setItem("authToken1", JSON.stringify(data.user));
        navigate("/");
      } else {
        toast({
          title: "Login Failed",
          description: data.message || "Invalid credentials.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "An error occurred.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Container
      bg={"#f1f1f1"}
      h={"100vh"}
      w={"full"}
      maxW={"full"}
      centerContent
      justifyContent={"center"}
    >
      <Flex
        backgroundColor={"#fff"}
        maxW={"container.sm"}
        w={"full"}
        shadow={"base"}
        borderRadius={"xl"}
        overflow={"hidden"}
        direction={{ base: "column", sm: "row" }}
      >
        <Image
          src="https://images.pexels.com/photos/719396/pexels-photo-719396.jpeg"
          alt="login"
          w={{ base: "full", sm: "400px" }}
          maxW={{ base: "full", sm: "250px" }}
          maxH={{ base: "200px", sm: "xs" }}
        />
        <Container w={"full"} maxW={"full"} p={5}>
          <CustomInput
            label1={"User Name"}
            placeholder1={"Enter User Name"}
            value1={username}
            onChange1={(e) => setUsername(e.target.value)}
          />
          <CustomInput
            label1={"Password"}
            placeholder1={"Enter Password"}
            type1={show ? "text" : "password"}
            value1={password}
            onChange1={(e) => setPassword(e.target.value)}
            rightElement1={
              show ? (
                <FiEyeOff
                  cursor={"pointer"}
                  size={18}
                  onClick={() => setShow(false)}
                />
              ) : (
                <FiEye
                  cursor={"pointer"}
                  size={18}
                  onClick={() => setShow(true)}
                />
              )
            }
          />
          <Text align={"right"} mt={2}>
            Forgot Password?
          </Text>
          <Center mt={5}>
            <CustomButton title={"Login"} onClick={handleLogin} />
          </Center>
        </Container>
      </Flex>
    </Container>
  );
};

export default Login;

// import { Center, Container, Flex, Image, Text } from "@chakra-ui/react";
// import React from "react";
// import CustomInput from "../components/CustomInput";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import CustomButton from "../components/ButtonComp";

// const Login = () => {
//   return (
//     <Container
//       bg={"#f1f1f1"}
//       h={"100vh"}
//       w={"full"}
//       maxW={"full"}
//       centerContent
//       justifyContent={"center"}
//     >
//       <Flex
//         backgroundColor={"#fff"}
//         maxW={"container.sm"}
//         w={"full"}
//         shadow={"base"}
//         borderRadius={"xl"}
//         overflow={"hidden"}
//         direction={{ base: "column", sm: "row" }}
//       >
//         <Image
//           //   src="bg.jpg"
//           src="https://images.pexels.com/photos/719396/pexels-photo-719396.jpeg?cs=srgb&dl=pexels-gabriel-peter-719396.jpg&fm=jpg"
//           alt="login"
//           w={{ base: "full", sm: "400px" }}
//           maxW={{ base: "full", sm: "250px" }}
//           maxH={{ base: "200px", sm: "xs" }}
//         ></Image>
//         <Container w={"full"} maxW={"full"} p={5}>
//           {/* <Heading fontSize={"lg"}>Login</Heading> */}
//           <CustomInput
//             label1={"User Name"}
//             onlyone
//             placeholder1={"Enter User Name"}
//             // value1={id}
//             // onChange1={(e) => setId(e.target.value)}
//           />
//           <CustomInput
//             label1={"Password"}
//             onlyone
//             placeholder1={"Enter Password"}
//             // type1={show ? "text" : "password"}
//             // value1={password}
//             // onChange1={(e) => setPassword(e.target.value)}
//             // right={
//             //   !show ? (
//             //     <FiEye cursor={"pointer"} size={18} onClick={handleClick} />
//             //   ) : (
//             //     <FiEyeOff cursor={"pointer"} size={18} onClick={handleClick} />
//             //   )
//             // }
//           />
//           <Text align={"right"} mt={2}>
//             Forgot Password?
//           </Text>
//           <Center mt={5}>
//             <CustomButton title={"Login"} />
//           </Center>
//         </Container>
//       </Flex>
//     </Container>
//   );
// };

// export default Login;
